import { getApiUrl, getCMSUrl } from './apiUrls';
import HTTPGetClient from './HTTPClient';

export const API = new HTTPGetClient({ baseUrl: getApiUrl(2) });
export const CMSAPI = new HTTPGetClient({ baseUrl: getCMSUrl() });
